var exports = {
  "u": "xfd349460--2b1d79--onboarding-wrapper",
  "G": "xfd349460--2b1d79--onboarding",
};

module.exports = exports;
